import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import PortalAwareItem from "./PortalAwareItem";

const Teams = ({ ...props }) => {
  const teams = props.boardData.filter((r) => r.colType === "teams");

  return (
    <div className="teams">
      {teams.map((board) => {
        return (
          <Droppable droppableId={board.id} key={board.id} type="team">
            {(dropProvided) => {
              return (
                <div {...dropProvided.droppableProps}>
                  <div className="teams__droppable" ref={dropProvided.innerRef}>
                    {board.items.map((item, iIndex) => (
                      <Draggable
                        key={item.id.toString()}
                        index={iIndex}
                        draggableId={item.id.toString()}
                      >
                        {(dragProvided, dragSnap) => {
                          return (
                            <PortalAwareItem
                              portal={props.portal}
                              usePortal={dragSnap.isDragging}
                              child={
                                <div
                                  {...dragProvided.dragHandleProps}
                                  {...dragProvided.draggableProps}
                                  ref={dragProvided.innerRef}
                                >
                                  <p
                                    className={
                                      dragSnap.isDragging
                                        ? "teams__team-active"
                                        : "teams__team"
                                    }
                                  >
                                    {item.name}
                                  </p>
                                </div>
                              }
                            />
                          );
                        }}
                      </Draggable>
                    ))}
                    {dropProvided.placeholder}
                  </div>
                </div>
              );
            }}
          </Droppable>
        );
      })}
    </div>
  );
};

export default Teams;
